"use client";

import { Heart, MessageCircle, Send, Bookmark } from 'lucide-react';

export default function InstagramPreview({
  username,
  imageUrl,
  caption,
}: {
  username?: string;
  imageUrl?: string;
  caption: string;
}) {
  const displayName = username?.trim() || 'make_my_brand';

  return (
    <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
      <div className="flex items-center gap-2 px-3 py-2">
        <div className="h-8 w-8 rounded-full bg-gradient-to-br from-pink-500 via-rose-500 to-amber-400" />
        <div className="min-w-0">
          <p className="truncate text-sm font-semibold text-gray-900">{displayName}</p>
          <p className="text-[11px] text-gray-500">Thought leadership</p>
        </div>
      </div>
      <div className="aspect-square bg-gray-100">
        {imageUrl ? (
          // eslint-disable-next-line @next/next/no-img-element
          <img src={imageUrl} alt="" className="h-full w-full object-cover" />
        ) : (
          <div className="flex h-full items-center justify-center text-sm text-gray-400">
            Image preview
          </div>
        )}
      </div>
      <div className="space-y-2 px-3 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 text-gray-800">
            <Heart className="h-5 w-5" />
            <MessageCircle className="h-5 w-5" />
            <Send className="h-5 w-5" />
          </div>
          <Bookmark className="h-5 w-5 text-gray-800" />
        </div>
        <p className="text-sm font-semibold text-gray-900">0 likes</p>
        <p className="whitespace-pre-wrap break-words text-sm text-gray-800">
          <span className="font-semibold">{displayName}</span>{' '}
          {caption || 'Your Instagram caption will appear here.'}
        </p>
        <p className="text-[11px] uppercase tracking-wide text-gray-400">Just now</p>
      </div>
    </div>
  );
}
